import { Segment, Header, Icon, Label } from "semantic-ui-react";

const SegmentHeader = ({ title, icon, labelCount }) => {
  return (
    <Segment clearing>
      <Header as="h3" floated="left" className="is-bottom-margined-none">
        <Icon
          name={icon}
          color="blue"
          circular
          inverted
          style={{ fontSize: "0.8em" }}
        />
        <Header.Content>{title}</Header.Content>
      </Header>
      <Label circular basic color="grey" style={{ float: "right" }}>
        {labelCount}
      </Label>
    </Segment>
  );
};

export default SegmentHeader;
